
import React from 'react';
import AuthorAndTime from '/components/authorAndTime';
import NewsItemParts from '/components/newsItemParts';
import { isMobile } from "react-device-detect";


class CarouselItemParts extends React.Component{
    render(){
        const { classes, item } = this.props;
        const color = item.category.color ? item.category.color : '#ed7123' ;
        return (
            <div style={{ position: 'absolute', bottom: isMobile ? 27 : 31, left: 14, zIndex: 1 }}>
                    <NewsItemParts item={item} 
                      isGraphicAndCover
                      isCover
                      isFeatureCover
                      color="#fff"
                      customStyle={{
                        position: 'relative',
                        left: 8,
                        marginRight: 20,
                        marginBottom: 8
                      }}
                      customTitleStyle={{
                        background: color,
                        boxShadow: `-8px 0 0 0 ${color}, 8px 0 0 0 ${color}`,
                        color: 'hsla(0,0%,100%,.92)',
                        display: 'inline',
                        padding: '4px 0px',
                        fontSize: 20,
                        lineHeight: '36px',
                        whiteSpace: 'initial',
                        fontWeight: 400,
                      }}
                     />
                      <AuthorAndTime item={item} linkColor="#fff" customStyle={{opacity: 1, color: '#fff'}} />
                  </div>
          );
        
    }
}


export default CarouselItemParts;